import constants from '@/const/'
import errors from '@/store/errors'

const actions = {
	getChapters ({ commit, rootState }) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.GET,
				apiName: 'seowork',
				url: '/project/ctr/list/folders',
				auth: true
			}).then(result => {
				commit('pushChapters', result)
				resolve(true)
			}, () => {
				reject(Error(errors.GET_DATA))
			})
		})
	},

	getChapter: function ({ commit, rootState }, input) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.GET,
				url: '/project/ctr/folder',
				apiName: 'seoworkNew',
				auth: true,
				query: {
					id: input
				}
			})
				.then(result => {
					commit('setChapter', result)
					resolve(result && result.status === 200)
				}, () => {
					reject(Error(errors.GET_DATA))
				})
		})
	},

	createChapter: function ({ rootState }, input) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.POST,
				url: '/project/ctr/folder',
				apiName: 'seoworkNew',
				auth: true,
				body: input
			})
				.then(result => {
					resolve(result && result.status === 200)
				}, () => {
					reject(Error(errors.CREATE))
				})
		})
	},

	updateChapter: function ({ rootState }, input) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.PUT,
				url: '/project/ctr/folder',
				apiName: 'seoworkNew',
				auth: true,
				body: input
			})
				.then(result => {
					resolve(result && result.status === 200)
				}, () => {
					reject(Error(errors.UPDATE))
				})
		})
	},

	createDictionary: function ({ rootState }, input) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.POST,
				url: '/project/ctr/dictionary',
				apiName: 'seoworkNew',
				auth: true,
				body: input
			})
				.then(result => {
					resolve(result && result.status === 200)
				}, () => {
					reject(Error(errors.CREATE))
				})
		})
	},

	updateDictionary: function ({ rootState }, input) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.PUT,
				url: '/project/ctr/dictionary',
				apiName: 'seoworkNew',
				auth: true,
				body: input
			})
				.then(result => {
					resolve(result && result.status === 200)
				}, () => {
					reject(Error(errors.UPDATE))
				})
		})
	},

	getDictionaryValues ({ commit, rootState }, input) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.GET,
				apiName: 'seoworkNew',
				url: '/project/ctr/dictionary/values',
				auth: true,
				query: {
					id: input
				}
			}).then(result => {
				commit('pushDictionaryValues', result)
				resolve(true)
			}, () => {
				reject(Error(errors.GET_DATA))
			})
		})
	},

	getCtrStructure ({ commit, rootState }) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.GET,
				apiName: 'seowork',
				url: '/project/ctr/list/structure',
				auth: true
			}).then(result => {
				commit('pushCtrStructure', result)
				resolve(true)
			}, () => {
				reject(Error(errors.GET_DATA))
			})
		})
	},

	sendSortChanges: function ({ rootState }, input) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.POST,
				url: '/project/ctr/list/structure',
				apiName: 'seowork',
				auth: true,
				body: {
					data: input
				}
			})
				.then(result => {
					resolve(result && result.status === 200)
				}, () => {
					reject(Error(errors.CREATE))
				})
		})
	}
}

export default actions
